import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import { MissingBruksklasse, RoadFeaturesWithBruksklasse } from "../../services/RuteplanAPI";

export function MissingBruksklasseItem(props: IRoutePartProps) {
    
    const roadFeatures = props.roadFeatures as RoadFeaturesWithBruksklasse;

    return (
         <>
            {roadFeatures && roadFeatures.missingBruksklasser && roadFeatures.missingBruksklasser.length > 0 &&            
                <List>         
                    {roadFeatures.missingBruksklasser.map( (mb: MissingBruksklasse, index: number) => (
                    <>
                        <ListItem 
                        key={`${mb.roadId} - ${index}`}
                        className="roadFeature"
                        onClick={(event) => {props.onClick(mb, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(mb)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            Manglende bruksklasse: {mb.message}-{(mb as any).roadId}                            
                        </ListItem>
                    </>
                    
                    ))}
                </List>       
            }
        </>
    )
}